<template>
  <el-container id="glTimingSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="main_glTimingSon">
      <el-main style="background: #FFFFFF;padding-bottom:60px">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:left;align-items:center;margin-left:40px">
            <span style="width:80px; margin-left:10px; color: #000000; font-size: 13px">
               定时名称：
            </span>
          <el-input
              placeholder="请输入定时名称"
              style="width:25vw;"
              clearable
              v-model="TimingName">
          </el-input>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
            定时时间：
          </span>
          <el-time-picker
              v-model="times"
              style="width:25vw;"
              :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
              }"
              placeholder="请选择时间">
          </el-time-picker>
        </div>
        <!--        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
                    <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
                       所属区域：
                    </span>
                  <el-select v-model="edi_auth" ref='select1' @change="init_View()"
                             @visible-change='show_change1'
                             clearable filterable placeholder="请选择楼栋"
                             style="width:5vw;">
                    <el-option
                        v-for="item in li_auth"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="edi_auth" ref='select2' @change="init_View()"
                             @visible-change='show_change2'
                             clearable filterable placeholder="请选择楼层"
                             style="width:5vw;margin-left:10px">
                    <el-option
                        v-for="item in li_auth"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="edi_auth" ref='select3' @change="init_View()"
                             @visible-change='show_change3'
                             clearable filterable placeholder="请选择房间"
                             style="width:5vw;margin-left:10px">
                    <el-option
                        v-for="item in li_auth"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </div>-->
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               执行周期：
            </span>
          <el-checkbox-group v-model="check_rqS" @change="checksChange(check_rqS)"
                             style="margin-top:6px">
            <el-checkbox v-for="city in rqS" :label="city" :key="city">{{ city }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               执行内容：
            </span>
          <span style="color: #BDBDBD">请先将执行设备和内容加到场景中</span>
        </div>
        <!--        <div style="margin-top:15px;margin-left:130px">-->
        <!--          <span>执行设备</span>-->
        <!--        </div>-->
        <!--        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">-->
        <!--          <el-button type="primary">选择设备</el-button>-->
        <!--          <el-button type="primary">选择执行内容</el-button>-->
        <!--        </div>-->
        <div style="margin-top:15px;margin-left:130px">
          <el-button @click="addDev" type="primary">添加执行场景</el-button>
        </div>
        <div v-for="(tab,ite) in li_Scene_xz" :key=ite
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">
          <el-select v-model="tab.edi_scene" ref='select' @click.native="getScene"
                     clearable filterable placeholder="请选择场景"
                     style="width:25vw;">
            <el-option
                v-for="item in li_Scene"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <i @click="del_dev(tab.id)" class="el-icon-circle-close"
             style="font-size:20px;color:red;margin-left:15px"></i>
        </div>
        <div
            style="display:flex;justify-content:left;align-items:center;margin-top:20px;margin-left:130px">
          <el-button @click="onBack" size="medium">取消</el-button>
          <el-button v-if="!is_ble" @click="onKeep" size="medium" type="primary">保存</el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name:"glTimingSon",
  computed:{},
  data(){
    return {
      is_ble:false,
      page:1,
      pageSize:10,
      total:10,
      isCtr:true,
      isScene:false,
      h_text:"新增定时",
      li_h_text:[
        {"text":"节能策略","colour":"#B7B7B7","pages":""},
        {"text":"定时策略","colour":"#B7B7B7","pages":""}
      ],
      times:new Date(),
      rqS:[
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "日"
      ],
      check_rqS:[
        "一",
        "二",
        "三",
        "四",
        "五"
      ],
      checkAll:false,
      isIndeterminate:false,
      id:"",
      li_Scene:[],
      li_Scene_xz:[],
      TimingName:"",
      passWd:"",
      nickName:"" /*账号*/
    };
  },
  methods:{ /*方法存放*/
    addDev(){
      if(this.li_Scene_xz.length > 0) {
        this.li_Scene_xz.push({
          id:this.li_Scene_xz[this.li_Scene_xz.length - 1]["id"] + 1,
          edi_scene:""
        });
      } else {
        this.li_Scene_xz.push({
          id:0,
          edi_scene:""
        });
      }
    },
    del_dev(id){
      const index = this.li_Scene_xz.findIndex(item => item.id === id);
      this.li_Scene_xz.splice(index,1);
    },
    checksChange(val){
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.rqS.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
    },
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item){
      if(item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item){
      if(item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item){
      if(item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    onKeep(){
      if(this.isCtr) {
        this.isCtr = false;
        if(this.h_text === '新增定时') {
          this.addTiming();
        } else {
          this.changeTiming();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    get_zq(zq){
      let j = 0;
      if(zq.includes("日")) {
        j += 1;
      }
      if(zq.includes("一")) {
        j += 2;
      }
      if(zq.includes("二")) {
        j += 4;
      }
      if(zq.includes("三")) {
        j += 8;
      }
      if(zq.includes("四")) {
        j += 16;
      }
      if(zq.includes("五")) {
        j += 32;
      }
      if(zq.includes("六")) {
        j += 64;
      }
      return j;
    },
    addTiming(){
      const params = {
        'name':this.TimingName,
        'cycle':0,
        'hour':this.times.getHours(),
        'minute':this.times.getMinutes(),
        'second':this.times.getSeconds(),
        'enable':true,
        'isBle':false,
        'scene':[],
        'projectId':localStorage.getItem("projectId")
      };
      if(this.check_rqS.length > 0) {
        params['timerTypeId'] = 2;
        params['cycle'] = this.get_zq(this.check_rqS);
      } else {
        params['timerTypeId'] = 1;
      }
      let li_a = [];
      for(let i = 0; i < this.li_Scene_xz.length; i++) {
        if(!this.li_Scene_xz[i]["edi_scene"]) {
          this.$message.error("请先选择执行内容");
          return;
        }
        let exists = li_a.includes(this.li_Scene_xz[i]["edi_scene"]); /*筛选字典数组*/
        if(exists) {
          this.$message.error("一次不能添加多个相同场景");
          return;
        } else {
          li_a.push(this.li_Scene_xz[i]["edi_scene"]);
        }
        params['scene'].push({
          'id':this.li_Scene_xz[i]["edi_scene"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addTimer,params,headers).then(res => {
        console.log("addTimer",res.data.data);
        this.$message.success("添加定时成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("添加定时失败");
        }
      });
    },
    changeTiming(){
      console.log(this.time_id);
      const params = {
        'id':this.time_id,
        'name':this.TimingName,
        'cycle':0,
        'hour':this.times.getHours(),
        'minute':this.times.getMinutes(),
        'second':this.times.getSeconds(),
        'enable':true,
        'isBle':false,
        'scene':[],
        'projectId':localStorage.getItem("projectId")
      };
      if(this.check_rqS.length > 0) {
        params['timerTypeId'] = 2;
        params['cycle'] = this.get_zq(this.check_rqS);
      } else {
        params['timerTypeId'] = 1;
      }
      let li_a = [];
      for(let i = 0; i < this.li_Scene_xz.length; i++) {
        if(!this.li_Scene_xz[i]["edi_scene"]) {
          this.$message.error("请先选择执行内容");
          return;
        }
        let exists = li_a.includes(this.li_Scene_xz[i]["edi_scene"]); /*筛选字典数组*/
        if(exists) {
          this.$message.error("一次不能添加多个相同场景");
          return;
        } else {
          li_a.push(this.li_Scene_xz[i]["edi_scene"]);
        }
        params['scene'].push({
          'id':this.li_Scene_xz[i]["edi_scene"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.updateTimer,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack(){
      this.$router.go(-1);
    },
    getScene(){
      if(this.page <= this.total / this.pageSize + 1) {
        const params = {
          'page':this.page,
          'all':true,
          'pageSize':this.pageSize,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.getSceneList,params,headers).then(res => {
          console.log(res.data.data);
          this.total = res.data.data.total;
          let l_d = [];
          if(this.isScene) {
            l_d = this.li_Scene;
          }
          const li_d = res.data.data["list"];
          for(let i = 0; i < li_d.length; i++) {
            const d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            d['roomName'] = "";
            d['floorName'] = "";
            d['buildName'] = "";
            if(li_d[i]['room']) {
              d['roomName'] = li_d[i]['room']['name'];
              d['floorId'] = li_d[i]['room']['floorId'];
              if(li_d[i]['room']['floor']) {
                d['floorName'] = li_d[i]['room']['floor']['name'];
                d['buildId'] = li_d[i]['room']['floor']['buildingId'];
                if(li_d[i]['room']['floor']['building']) {
                  d['buildName'] = li_d[i]['room']['floor']['building']['name'];
                }
              }
            }
            d["label"] = li_d[i]['name'] + ` (${d['buildName']}/${d['floorName']}/${d['roomName']})`;
            l_d.push(d);
          }
          this.isScene = true;
          this.li_Scene = l_d;
          if(this.page <= this.total / this.pageSize) {
            this.page += 1;
            this.getScene();
          } else {
            this.page += 1;
          }
        }).catch(error => {
          console.log(error);
          if(error) {
            this.$message.error("获取场景信息失败");
          }
        });
      }
    },
    initZq(cycle){
      this.check_rqS = [];
      let zq = parseInt(cycle).toString(2);
      var paddingLength = 7 - zq.length;
      for(let i = 0; i < paddingLength; i++) {
        zq = '0' + zq;
      }
      if(zq[5].includes("1")) {
        this.check_rqS.push("一");
      }
      if(zq[4].includes("1")) {
        this.check_rqS.push("二");
      }
      if(zq[3].includes("1")) {
        this.check_rqS.push("三");
      }
      if(zq[2].includes("1")) {
        this.check_rqS.push("四");
      }
      if(zq[1].includes("1")) {
        this.check_rqS.push("五");
      }
      if(zq[0].includes("1")) {
        this.check_rqS.push("六");
      }
      if(zq[6].includes("1")) {
        this.check_rqS.push("日");
      }
    },
    initTimes(hour,minute,second){
      this.times = new Date(0,0,0,hour,minute,second);
    },
    initScene(l_s){
      this.li_Scene_xz = [];
      for(let i = 0; i < l_s.length; i++) {
        if(this.li_Scene_xz.length > 0) {
          this.li_Scene_xz.push({
            id:this.li_Scene_xz[this.li_Scene_xz.length - 1]["id"] + 1,
            edi_scene:l_s[i]["id"]
          });
        } else {
          this.li_Scene_xz.push({
            id:0,
            edi_scene:l_s[i]["id"]
          });
        }
        this.li_Scene.push({
          value:parseInt(l_s[i]["id"]),
          label:l_s[i]["name"]
        });
      }
    }
  },
  mounted(){ /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(value);
    if(value === "addTiming") {
      this.h_text = "新增定时";
    } else {
      this.h_text = "修改定时信息";
      this.time_id = parseInt(this.$route.query.id);
      this.TimingName = this.$route.query.name;
      const hour = this.$route.query.hour;
      const minute = this.$route.query.minute;
      const second = this.$route.query.second;
      this.initTimes(hour,minute,second);
      this.initZq(this.$route.query.cycle);
      this.initScene(this.$route.query.scene);
    }
    if(localStorage.getItem("is_ble_timing") === "1") {
      this.is_ble = true;
    } else {
      this.is_ble = false;
    }
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#glTimingSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.main_glTimingSon {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/timingSon.vue